
export const auditPlanningTemplatesData = {
  "Define Scope": {
    templateType: "Scope Template",
    title: "Audit Scope Document",
    auditTitle:
      '[Enter the title of the audit, e.g., "Quarterly Financial Controls Audit"]',
    background:
      "Provide context and background information that explains why this audit is being conducted.",
    objectives: [
      "Define what the audit intends to achieve.",
      "Identify the key areas and processes to review.",
      "Ensure alignment with overall business risks and priorities.",
    ],
    scope: {
      inScope: {
        departments: "[List relevant departments]",
        processes:
          "[List processes, e.g., revenue recognition, procurement]",
        timePeriod: "[Specify the period covered, e.g., Q1 2025]",
      },
      outOfScope:
        "Areas not included in this audit, along with any constraints.",
    },
    limitations:
      "Any known limitations such as resource availability or data access issues.",
    keyStakeholders:
      "List names and roles of key personnel, including contacts from audited departments.",
    approvalSection: {
      preparedBy: "[Name, Title]",
      date: "[Preparation Date]",
      reviewedBy: {
        name: "[Reviewer's Name]",
        title: "[Reviewer's Title]",
        dateOfReview: "[Insert Date]",
      },
      signOff: "[Signature and Date]",
    },
  },
  "Risk Assessment": {
    templateType: "Risk Assessment Template",
    title: "Audit Risk Assessment",
    objective:
      "To identify and prioritize potential risks in the audited areas, providing a basis for focusing the audit efforts.",
    riskIdentification: [
      {
        riskArea: "[e.g., Revenue Recognition]",
        description: "Briefly describe the risk.",
        potentialImpact: "What could go wrong if not controlled?",
        likelihood: "High / Medium / Low",
      },
      {
        riskArea: "[e.g., Procurement Process]",
        description: "Description of the risk.",
        potentialImpact: "Description of the impact.",
        likelihood: "High / Medium / Low",
      },
    ],
    riskAnalysis: {
      riskScore:
        "A numerical value (if applicable) based on likelihood and impact.",
      mitigationMeasures:
        "Suggestions on how the risk can be managed or mitigated.",
    },
    summary:
      "A brief overview of the key risks and their implications on the audit. Recommendations on areas that need a deeper review during the audit.",
    appendix:
      "Attach any supporting documents or data that were used to assess the risks.",
  },
  "Develop Audit Plan": {
    templateType: "Audit Plan Template",
    title: "Audit Plan Document",
    auditTitle: "[Enter the Audit Title]",
    auditObjectives: [
      "Clearly state what the audit intends to accomplish.",
      "List specific objectives based on the identified risks and scope.",
    ],
    scope:
      "Summarize the in-scope areas (referencing the Scope Template) and any exclusions.",
    methodology: {
      approach:
        "Describe the audit approach (e.g., risk-based, compliance-focused).",
      procedures:
        "List the audit procedures to be performed (interviews, document reviews, data analytics).",
      toolsAndTechniques:
        "Identify any audit software or analytical tools used.",
    },
    timelineAndMilestones:
      "Provide a detailed timeline with key milestones and deadlines. Include phases such as planning, fieldwork, and reporting.",
    resourcesAndTeam:
      "List the audit team members and their roles. Specify any additional resources required (external experts, technology).",
    deliverables:
      "Define the expected outputs (draft report, final report, management presentation).",
    monitoringAndAdjustments:
      "Outline how progress will be monitored and what processes are in place to handle changes during the audit.",
    reviewAndFeedback:
      "Detail the process for reviewing the audit plan with stakeholders and incorporating their feedback.",
  },
  "Obtain Approval": {
    templateType: "Approval Template",
    title: "Audit Plan Approval Form",
    auditTitle: "[Enter the Audit Title]",
    preparedBy: "[Name, Position]",
    datePrepared: "[Insert Date]",
    approvalSection: {
      reviewedBy: {
        name: "[Reviewer’s Name]",
        title: "[Reviewer’s Title]",
        dateOfReview: "[Insert Date]",
      },
      approvalDecision:
        "Approved / Not Approved (circle one)",
      comments:
        "[Provide any remarks or required changes]",
    },
    signatures: {
      auditManagerSignature: "[Signature Line]",
      managementRepresentativeSignature: "[Signature Line]",
      date: "[Insert Date]",
    },
  },
};
